import { TableCell, TableCellProps, Theme } from '@mui/material';
import { styled } from '@mui/styles';

interface Props {
  theme: Theme;
  paddingPmi?: string;
}

export const PmiHeadTableCell = styled((props: TableCellProps) => <TableCell {...props} />)(
  ({ theme, paddingPmi }: Props) => ({
    borderBottom: `1px solid ${theme.palette.primary.main} !important`,
    borderTop: `1px solid ${theme.palette.primary.main} !important`,
    padding: paddingPmi || '8px 16px !important',
  })
);
